
import {
  Vue,
  Component,
  Prop,
  PropSync,
  Watch,
  Inject,
} from "vue-property-decorator";
import { Action, Getter, State } from "vuex-class";
import InputForm from "@/components/base/form/InputForm.vue";
import UnitDialog from "@/components/semantics/ApplyUnitDialog.vue";
import PersonDialog from "@/components/semantics/ApplyPersonDialog.vue";
import config, { FormConfig, FormValid } from "@/config";
import { deepClone, getAreaCN } from "@/common/utils";
import { Loading } from "element-ui";

@Component({
  name: "Apply",
  components: {
    PersonDialog,
    UnitDialog,
    InputForm,
  },
})
export default class Apply extends Vue {
  areaOption: any = this.$root.$data.areaOption;
  @Getter("phone") private phone!: string;
  @Getter("role") private role!: string;
  @Getter("id") private id!: string;
  @Action("batchDownload") private batchDownload: any;
  @Action("upload") private upload: any;
  @Action("getDecrypt") private getDecrypt: any;
  @Action("policy/addApplyPolicyView") private addApplyPolicyView: any;
  @Action("policy/getApplyDetail") private getApplyDetail: any;
  @Action("policy/applyProject") private applyProject: any;
  @Action("policy/getApplyData") private getApply: any;
  @Action("account/getAuthernData") private getAuthern: any;
  @Action("account/getBasic") private getBasic: any;
  @Action("account/star") private star: any;
  @Action("account/unStar") private unStar: any;
  @Getter("roleSave") private roleSave!: any;
  isFollow: any = false;
  currentStater: any = 1; // 当前弹框状态 -1 审核不通过 1待提交 2 已提交  3 审核中 4 审核已通过 5 公示中
  currentList: any = [];
  action: any = `${config.basicUrl}zst/page/itemDeclareForm/uploadingFile`;
  formNameP = "formP";
  formNameU = "formU";
  labelWidth: any = "160px";
  unit_roles: any = ["unit", "declare"];
  isDialogU = false;
  isDialogP = false;
  isOpen = true;
  formDataP: any = {
    userName: "",
    papersNumber: "",
    contactInform: "",
    address: "",
  };
  settingP: any = [
    {
      label: "姓名",
      ref: "userName",
      disabled: true,
      type: "input",
      span: 12,
    },
    {
      label: "身份证号",
      disabled: true,
      ref: "papersNumber",
      type: "input",
      span: 12,
    },
    {
      label: "联系方式",
      ref: "contactInform",
      type: "input",
      span: 12,
    },
    {
      label: "联系地址",
      ref: "address",
      type: "input",
      span: 24,
    },
  ];
  formDataU: any = {
    unitName: "",
    unitSoleNumber: "",
    unitType: "",
    industry: "",
    address: "",
  };
  settingU: any = [
    {
      label: "企业名称",
      ref: "unitName",
      disabled: true,
      type: "input",
      span: 12,
    },
    {
      label: "统一社会信用代码",
      ref: "unitSoleNumber",
      disabled: true,
      type: "input",
      span: 12,
    },
    {
      label: "企业类型",
      ref: "unitType",
      span: 12,
      disabled: true,
      type: "cascader",
      options: FormConfig.unit_type,
    },
    {
      label: "所属行业",
      type: "cascader",
      ref: "industry",
      disabled: true,
      span: 12,
      options: FormConfig.industry,
    },
    {
      label: "企业地址",
      ref: "address",
      type: "input",
      disabled: true,
      span: 24,
    },
  ];
  fileList: any = [];
  currentUrl: any = "";
  beforeUploadFile(file: any, item: any) {
    let isEmpty = file.size > 0;
    const nameArray = file.name.split(".");
    let type = nameArray[nameArray.length - 1];
    const supportType = ["pdf", "pptx", "ppt", "xls", "xlsx", "doc", "docx"];
    let isVedio = supportType.includes(type);
    let isLt100M = file.size / 1024 / 1024 < 5;
    if (!isEmpty) {
      this.$message.error("不能上传空文件");
      return false;
    } else if (!isVedio) {
      this.$message.error(
        "只能上传.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx类型文件"
      );
      return false;
    } else if (!isLt100M) {
      this.$message.error("只能上传5M以内的文件");
      return false;
    }
  }
  httpRequest(file: any, id: any) {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    return new Promise((resolve, reject) => {
      const options = new FormData();
      options.append("file", file.file);
      this.upload(options).then(({ code, data, msg }: any) => {
        if (code === 0) {
          // 当当前的上传文件列表有值时，且该值和当前上传的文件所在位置一致

          this.fileList[id] = [
            {
              url: data,
              id,
            },
          ];
          loading && loading.close();
          resolve(data);
          return data;
        }
        reject(msg);
      });
    }).finally(() => loading.close());
  }
  downloadModal() {
    // batchDownload
    const fileList = this.material
      .map(({ templateUrl: filePath }: any) => {
        return encodeURIComponent(filePath);
      })
      .filter((item: any) => {
        return item !== "undefined";
      });
    if (fileList.length === 0) {
      return this.$message.warning("无模板文件");
    }
    const direction = this.direction.find((item: any) => {
      return item.id === this.current_direction_id;
    });
    const baseURL =
      process.env.NODE_ENV === "development"
        ? config.basicUrl
        : `${location.origin}/`;
    let fullURL = `${baseURL}zst/user/file/batchDownload?filePath=${fileList.join(
      ","
    )}&fileName=${
      this.title +
      "(" +
      (direction ? direction.dispatchDirection : direction) +
      ")"
    }`;
    window.open(fullURL);
  }
  beforeRemove(file: any) {}

  handleRemove(file: any, fileList: any, id: any) {
    this.fileList[id] = fileList;
    return fileList;
  }
  isTimeOut: any = false;
  @Watch("current_direction", { immediate: true })
  handleCurrentDirectionChange(newValue: any, oldValue: any) {
    if (newValue && newValue.gmtEnd) {
      const endDate = new Date(newValue.gmtEnd);
      const currentDate = new Date();
      if (currentDate.getTime() > endDate.getTime()) {
        this.isTimeOut = true;
      }
    }

    if (newValue && newValue.gmtCreate) {
      const createDate = new Date(newValue.gmtCreate);
      const currentDate = new Date();
      if (currentDate.getTime() < createDate.getTime()) {
        this.isOpen = false;
      }
    }
  }
  isApply: any = false;
  showDialog() {
    if (!this.id) {
      this.$confirm("您尚未登录,是否跳转登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const options: any = this.$route.query;
          this.$router.push({
            name: "Login",
            params: {
              beforePath: this.$route.path,
              beforeOption: options,
            },
          });
        })
        .catch(() => {
          this.$router.push({
            path: "/pcm/apply",
          });
        });

      this.isLogin = false;
      return;
    }
    if (this.roleSave != 1 || (!this.roleSave && this.role)) {
      this.$confirm("您尚未实名,是否跳转实名?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({ path: `/${this.role}/authern` });
        })
        .catch(() => {
          this.$message.warning("请先实名后再进行此操作");
        });
      return;
    }
    if (this.isApply) {
      return this.$message.warning("该项目已被提交，不能被修改!");
    }
    if (this.unit_roles.includes(this.role)) {
      this.isDialogU = true;
    } else {
      this.isDialogP = true;
    }
  }
  toPolicy({ id: policyId }: any) {
    this.$router.push({
      path: "/pcm/describepolicy",
      query: { policyId },
    });
  }
  handleCloseP() {
    this.isDialogP = false;
    this.getData(1);
  }

  handleCloseU() {
    this.isDialogU = false;
    this.getData(1);
  }

  toMaterail() {}
  isLogin = true;
  projectId: any = this.$route.query.id;
  directionId: any = this.$route.query.id;
  activeNav: any = 0;
  navList: any = [];
  show = false;
  toggleTab: any = 0;
  title: any = "";
  current_direction_id: any = "";
  current_direction: any = {};
  direction: any = [];
  basic: any = {};
  branch: any = "";
  contact: any = [];
  describe: any = "";
  condition: any = "";
  material: any = [];
  materialIdList: any = [];
  policy: any = [];
  publicy: any = [];
  department: any = "";
  savedMaterial: any = [];
  staterFlag: any = 1;
  disabled: any = false;
  async unFollow() {
    const options = {
      pageId: this.projectId,
      userId: this.id,
      type: "申报类",
    };
    const { code, data } = await this.unStar(options);
    if (code === 0 && data) {
      this.isFollow = false;
      this.$message.success("成功取消关注!");
    }
  }
  async follow() {
    const options = {
      pageId: this.projectId,
      userId: this.id,
      type: "申报类",
    };
    const { code, data } = await this.star(options);
    if (code === 0 && data) {
      this.$message.success("成功关注!");
      this.isFollow = true;
    }
  }
  async created() {
    const projectId = this.$route.query.id;
    this.addApplyPolicyView(projectId);
    this.getData();
  }

  async getData(state = 0) {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.isApply = false;
    this.disabled = false;
    let declareItemDirectionId = this.directionId;
    if (state === 1) {
      declareItemDirectionId = this.current_direction_id[0];
    }
    this.currentStater = 0;
    setTimeout(() => {
      loading && loading.close();
    }, 30000);
    await this.getApplyDetail({ declareItemId: this.projectId }).then(
      ({ code, data, msg }: any) => {
        if (code === 0) {
          const { whetherFollow } = data;
          this.isFollow = whetherFollow;
          this.setMenu(data);
          loading && loading.close();
          return data;
        }
        return data;
      }
    );
    if (!this.id) {
      this.isLogin = false;
      loading && loading.close();
      return;
    }
    if (this.roleSave != 1 || !this.roleSave) {
      return;
    }
    await this.getApply({
      userId: this.id,
      declareItemId: this.projectId,
      declareItemDirectionId,
    }).then(async ({ code, data, msg }: any) => {
      if (code == 0 && data) {
        const {
          contactDetails: contactInform,
          contactAddress: address,
          alreadySubmittedMaterials: material,
          stater,
        } = data;
        this.currentStater = stater || 0;
        this.currentList = material
          .filter((item: any) => {
            if (item.declareItemMaterialId) {
              return true;
            }
          })
          .map(({ fileUrl: url, declareItemMaterialId: id }: any) => {
            return {
              url,
              id,
            };
          });
        this.fileList = {};
        for (let currentMaterial of this.currentList) {
          if (
            currentMaterial.url &&
            this.materialIdList.includes(currentMaterial.id)
          ) {
            // this.fileList[item.declareItemMaterialId] = {};
            const oritinalName = await this.getDecrypt(currentMaterial.url);
            const { request } = oritinalName;
            const { response } = request;
            const fileName =
              response.split("-")[response.split("-").length - 1];
            this.fileList[currentMaterial.id] = [
              { url: currentMaterial.url, name: fileName },
            ];
          }
        }

        // 是否关注
        this.staterFlag = stater;
        this.isApply = stater === 2;

        this.savedMaterial = material;
        const addedData = {
          contactInform,
          address,
        };

        this.formDataP.address = address;
        this.formDataP.contactInform = contactInform;
        return data;
      }
    });
    await this.getAuthern().then((data: any) => {
      if (!data) {
        loading && loading.close();
        return this.$message.warning("您尚未进行实名认证,请先进行实名!");
      }
      if (!this.unit_roles.includes(this.role)) {
        const { userName, papersNumber } = data;
        this.formDataP.userName = userName;
        this.formDataP.papersNumber = papersNumber;
      }
      return data;
    });

    if (this.unit_roles.includes(this.role)) {
      await this.getBasic({ unitId: this.id }).then(
        ({ code, data, msg }: any) => {
          if (code === 0 && data) {
            const { unitCode } = data;
            if (unitCode) {
              const {
                creditCode,
                unitName,
                unitNature,
                organizationType,
                theirIndustry,
                belongsToField,
                signInAddress,
                detailedAddress,
                registeredAddress,
              } = unitCode;
              // 实名认证数据
              this.formDataU.unitSoleNumber = creditCode;
              this.formDataU.unitName = unitName;
              // 基础信息数据
              this.formDataU.unitNature = [unitNature];
              this.formDataU.unitType = [organizationType];
              this.formDataU.industry = [theirIndustry];
              // this.formDataU.coAddress = registeredAddress;
              this.formDataU.address = detailedAddress;
            }
          }
        }
      );
    }
  }
  downloadUpFile(item: any) {
    const { url } = item[0];
    if (!item) {
      return this.$message.warning("不存在该文件");
    }
    const baseURL =
      process.env.NODE_ENV === "development"
        ? config.basicUrl
        : `${location.origin}/`;
    let fullURL = `${baseURL}zst/user/file/downloadFile?filePath=${encodeURIComponent(
      url
    )}`;
    window.open(fullURL);
  }
  downloadFile(item: any) {
    const url = item.templateUrl;
    const baseURL =
      process.env.NODE_ENV === "development"
        ? config.basicUrl
        : `${location.origin}/`;
    let fullURL = `${baseURL}zst/user/file/downloadFile?filePath=${encodeURIComponent(
      url
    )}`;
    window.open(fullURL);
  }
  async setMenu(item: any) {
    const {
      policies, // 相关政策
      title, // 申报方向
      declareItemDirections: direction, // 基本信息
      stater: backStater, // 后台状态
      department: branch, // 主管部门
      contact, // 联系人
    } = item;
    this.disabled = false;
    if (backStater != 3) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
    // const {stater: currentStater} = declareItem;
    // switch(currentStater) {
    //   case "待提交": this.currentStater = 1; break;
    //   case "已提交": this.currentStater = 2; break;
    //   default: break;
    // }
    const menuList = [];
    let index = 0;
    if (policies.length) {
      this.policy = policies;
    }
    if (title) {
      menuList.push({
        label: "政策名称",
        ref: "title",
        index,
      });
      this.title = title;
      index++;
    }
    menuList.push({
      label: "基本信息",
      ref: "basic",
      index,
    });
    index++;
    if (direction.length) {
      menuList.push({
        label: "申报方向",
        ref: "direction",
        index,
      });
      this.direction = direction.map((item: any) => {
        const {
          id: value,
          department,
          dispatchDirection,
          declareItemMaterials: material,
        } = item;
        return {
          value,
          label: this.title + "(" + dispatchDirection + ")",
          departmentName: department ? department.departmentName : null,
          ...item,
        };
      });
      this.current_direction = direction.map((itm: any) => {
        const {
          id: value,
          dispatchDirection,
          declareItemMaterials: material,
          department,
          attendance,
          supportAmount,
          dispatchObject,
          contact,
          declareItemContactPersons,
        } = itm;
        declareItemContactPersons.map((item: any) => {
          const addressCN = getAreaCN(this.areaOption, item.zoning);
          item.zoning = addressCN.label;
          return item;
        });
        material.map((item: any) => {
          this.materialIdList.push(String(item.id));
          return item;
        });
        // currentList
        // this.fileList
        return {
          dispatchObject,
          attendance,
          supportAmount,
          departmentName: department ? department.departmentName : null,
          value,
          label: this.title + "(" + dispatchDirection + ")",
          material,
          declareItemContactPersons,
          ...itm,
        };
      })[0];
      // if (!this.current_direction) {
      // 	return this.errorRole();
      // }
      const {
        acceptanceConditions: condition,
        description: describe,
        material,
        declareItemContactPersons,
      } = this.current_direction;
      if (this.savedMaterial.length) {
        material.map((item: any) => {
          // item.declareItemMaterialId===
          const temp = this.savedMaterial.filter((itm: any) => {
            if (String(itm.declareItemMaterialId) === String(item.id)) {
              return itm;
            }
          });

          item.fileUrl = temp.length !== 0 ? temp[0].fileUrl : "";
          return item;
        });
        // 设置当前的申报项目数据
        this.fileList = {};

        for (let currentMaterial of this.currentList) {
          if (
            currentMaterial.url &&
            this.materialIdList.includes(currentMaterial.id)
          ) {
            // this.fileList[item.declareItemMaterialId] = {};
            const oritinalName = await this.getDecrypt(currentMaterial.url);
            const { request } = oritinalName;
            const { response } = request;
            const fileName =
              response.split("-")[response.split("-").length - 1];
            this.fileList[currentMaterial.id] = [
              { url: currentMaterial.url, name: fileName },
            ];
          }
        }
      }
      this.material = material.map((item: any) => {
        if (!item.templateUrl) {
          item.noModal = false;
        } else {
          item.noModal = true;
        }
        item.r_other = [];
        if (item.isSignature === 1) {
          item.r_other.push("必须签字");
        }
        if (item.isStamp === 1) {
          item.r_other.push("必须盖章");
        }
        return item;
      });
      this.current_direction_id = this.directionId;
      index++;
      if (branch) {
        menuList.push({
          label: "主管部门",
          ref: "branch",
          index,
        });
        index++;
        this.branch = branch;
      }
      if (declareItemContactPersons.length > 0) {
        menuList.push({
          label: "联系人",
          ref: "contact",
          index,
        });
        index++;
        direction.map((item: any) => {
          if (item.declareItemContactPersons.length > 0) {
            this.contact = item.declareItemContactPersons;
          }
        });
      }
      if (describe) {
        menuList.push({
          label: "项目描述",
          ref: "describe",
          index,
        });
        index++;
        this.describe = describe;
      }
      if (condition) {
        menuList.push({
          label: "受理条件",
          ref: "condition",
          index,
        });
        index++;
        this.condition = condition;
      }
      if (this.material) {
        menuList.push({
          label: "申报材料",
          ref: "material",
          index,
        });
        index++;
      }
    }

    this.navList = menuList;
    const unitList = ["company", "unit", "declare"];
    if (this.role && this.current_direction.dispatchObject !== this.role) {
      if (!this.current_direction.dispatchObject) {
        return this.errorRole();
      }
      switch (this.role) {
        case "person":
          {
            if (this.current_direction.dispatchObject == "unit") {
              this.errorRole();
            }
          }
          break;
        case "declare":
          {
            if (this.current_direction.dispatchObject == "person") {
              this.errorRole();
            }
          }
          break;
        default:
          this.$router.push({ path: "/pcm/apply" });
          break;
      }
    }
  }
  errorRole() {
    this.$alert("当前项目和账户类型不匹配,准备启航", "提示", {
      confirmButtonText: "确定",
      callback: () => {
        this.$router.push({ path: "/pcm/apply" });
      },
    });
  }
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  }

  submitUnit(stater: any) {
    const {
      unitName,
      unitSoleNumber: creditCode,
      unitType,
      industry,
      address: unitAddress,
    } = this.formDataU;

    const material = [];
    for (const i in this.fileList) {
      if (this.fileList[i].length) {
        const { url: fileUrl } = this.fileList[i][0];
        material.push({
          declareItemMaterialId: i,
          fileUrl,
          stater: 1,
        });
      }
    }
    const options: any = {
      alreadySubmittedMaterials: material,
      // contactDetails:contactDetails[0],
      industry: industry[0] || null,
      unitAddress: unitAddress || null,
      stater,
      declareItemId: this.projectId,
      declareItemDirectionId: this.directionId,
      userId: this.id,
      unitType: unitType[0] || null,
    };
    if (stater === 2 && this.material.length !== material.length) {
      return this.$message.warning("请完整上传材料");
    }
    this.applyProject(options).then(({ code, data, msg }: any) => {
      if (code === 0) {
        this.getData(0);
        if (stater === 2) {
          this.isDialogU = false;
          return this.$message.success("提交成功!");
        }
        this.isDialogU = false;
        return this.$message.success("保存成功!");
      }
    });
  }

  submitPerson(stater: any) {
    const {
      userName: unitName,
      papersNumber: creditCode,
      contactInform: contactDetails,
      address: contactAddress,
    } = this.formDataP;
    // const tempMaterail = this.material.map((item: any) => {
    //   const {id:declareItemMaterialId,materialName,templateUrl,uploadRequest,stater} = item;
    //   return {}
    // })

    const material = [];
    for (const i in this.fileList) {
      if (this.fileList[i].length) {
        const { url: fileUrl } = this.fileList[i][0];
        material.push({
          declareItemMaterialId: i,
          fileUrl,
          stater: 1,
        });
      }
    }
    if (stater === 2 && this.material.length !== material.length) {
      return this.$message.warning("请完整上传材料");
    }
    const options: any = {
      alreadySubmittedMaterials: material,
      contactDetails,
      contactAddress,
      stater,
      declareItemId: this.projectId,
      declareItemDirectionId: this.directionId,
      unitType: this.role,
      userId: this.id,
    };

    this.applyProject(options).then(({ code, data, msg }: any) => {
      if (code === 0) {
        this.getData(0);
        if (stater === 2) {
          this.isDialogP = false;
          return this.$message.success("提交成功!");
        }
        this.isDialogP = false;
        return this.$message.success("保存成功!");
      }
    });
  }

  async save() {
    // for (let index = 0; index < this.currentList.length; index++) {
    //   const refName = 'upload' + index;
    //

    //   if ((this.$refs[refName] as any).length === 0) {
    //     return this.$message(`第${index}个文件为上传`)
    //   }
    //   // await (this.$refs[refName] as any)[0].submit();
    // }
    if (this.unit_roles.includes(this.role)) {
      this.submitUnit(1);
    } else {
      this.submitPerson(1);
    }
  }

  async submit() {
    for (let index = 0; index < this.currentList.length; index++) {
      const refName = "upload" + index;
      // await (this.$refs[refName] as any)[0].submit();
    }
    if (this.unit_roles.includes(this.role)) {
      this.submitUnit(2);
    } else {
      const valid = (this.$refs.applyPerson as any).validFormReturn();
      this.submitPerson(2);
    }
  }

  toggle(index: any) {
    this.toggleTab = index;
    const jump = document.querySelector(`#banner${index}`);

    jump?.scrollIntoView();
  }

  onScroll() {
    const scrollTop =
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      window.pageYOffset;
    const topList: any = document.getElementsByClassName("scroll-menu");
    const topArray: any = [];
    for (let i = 0; i < topList.length; i++) {
      topArray[i] = topList[i].offsetTop;
    }
    if (scrollTop >= 388) {
      this.show = true;
      for (let i = 0; i < topArray.length; i++) {
        if (i === 0) {
          if (scrollTop < topArray[i]) {
            return (this.activeNav = i);
          }
        } else if (i != topArray.length) {
          if (
            scrollTop >= topArray[i] &&
            i !== topList.length &&
            scrollTop < topArray[i + 1]
          ) {
            return (this.activeNav = i);
          }
        } else {
          if (scrollTop >= topArray[i]) {
            return (this.activeNav = i);
          }
        }
      }
    } else {
      this.activeNav = 0;
      this.show = false;
    }
  }

  // 下拉选择处理数据
  selectChange(data: any) {
    this.directionId = data; // 切换时，获取当前方向的方向id
    this.formDataP.contactInform = "";
    this.formDataP.address = "";
    this.getData(0);
    // this.direction.map((item: any) => {
    //   if(item.value == data) {
    //     // this.current_direction = item;
    //     // this.material = item.material;
    //     // const materialIdList: any = [];
    //     // item.material.map((item: any) => {
    //     //   materialIdList.push(String(item.id));
    //     // })
    //     // this.materialIdList = materialIdList;
    //     // this.currentList = item.material; // 切换时，获取当前方向的申报材料内容
    //     // this.contact = item.declareItemContactPersons;
    //     // this.describe = item.description;
    //     // this.condition = item.acceptanceConditions;
    //   }
    // });
  }
}
